import { useTranslation } from "react-i18next";
import BoldBlue from "./BoldBlue";

const Events = (props) => {

    const { i18n } = useTranslation('common');

    if(!props.events) return <></>;

    const allowedPrograms = [
        "SDE 2022",
        "SDE 2023",
        "SDE 2024",
        "Incubateur 2022",
        "Incubateur 2023",
        "SDO 2022",
        "SDO 2023",
        "FD100 2023",
        "FD100 2019",
        "FD100 2021/2022",
        "Le FD WORLD MAP",
        "Le FD 3D Catalogue",
        "Cahiers tendances 2022",
    ]

    const programmes = props.events.split(";").map((value) => value.trim().replace(/_/g, ' ')).filter((value) => allowedPrograms.some(p => p === value));

    return (
        <>
            {programmes && programmes.length > 0 && <BoldBlue>{i18n.language === "fr" ? "Programmes Le FRENCH DESIGN" : "Le FRENCH DESIGN programs"}</BoldBlue>}
            {programmes.map((programme, i) => {
                return (
                    <div key={programme + i}><span># Participant {programme}</span><br/></div>
                )
            })}
        </>
    );
}

export default Events;